<template>
  <div :class="$style.container">
    <div :class="$style.header">
      <h3
        v-m-r="20"
        v-color:red
        v-html="title"
      ></h3>

      <img src="~@/assets/images/common/access-denied.svg" alt="" />
    </div>

    <p
      v-if="message"
      v-html="message"
      :class="$style.message"
    ></p>

    <div v-if="$slots.hasOwnProperty('action')" :class="$style.action">
      <slot name="action" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'AccessDenied',
  props: {
    title: {
      type: String,
      required: true,
    },
    message: String,
  },
};
</script>

<style lang="sass" module>
  .container
    +base-card
    +font-type('regular', 12, 16)
    color: #212121

    +respond-to('medium')
      +font-type('regular', 14, 20)

  .header
    display: flex
    align-items: flex-start
    justify-content: space-between
    color: #FF5172

    h3
      +font-type('regular', 12, 16)

      +respond-to('medium')
        +font-type('regular', 14, 20)

    strong
      +font-weight('extra-bold')

      +respond-to('medium')
        +font-weight('semi-bold')

    img
      +size(30px)

      +respond-to('medium')
        +size(40px)

  .message
    margin-top: 15px

    +respond-to('medium')
      margin-top: 20px

    a
      color: var(--color-violet)

  .action
    margin-top: 15px

    +respond-to('medium')
      margin-top: 20px
</style>
